module.exports = __webpack_public_path__ + "static/media/ios-remove-circle.d6c012a4.svg";